import React from "react";
import styled from "styled-components";

import Header from "./Header";

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  align-items: center;
`;

export default function PageWrap({ children, noHeader, ...rest }) {
  return (
    <StyledDiv {...rest}>
      <Header hideHeader={noHeader} />
      {children}
    </StyledDiv>
  );
}
